module.exports = __webpack_public_path__ + "img/Zoom.bdf282dc.svg";